import React from 'react';
import { Play, MessageCircle, Instagram, ImageIcon, Star } from 'lucide-react';
export function SocialProof() {
  return <section className="py-16 md:py-24 px-4 bg-surface/30 border-y border-zinc-800/50" data-id="element-410">
      <div className="max-w-6xl mx-auto" data-id="element-411">
        <div className="text-center mb-12 md:mb-16" data-id="element-412">
          <h2 className="text-3xl md:text-5xl font-extrabold mb-6 tracking-tight" data-id="element-413">
            Resultados <span className="text-primary" data-id="element-414">Reales</span>
          </h2>
          <p className="text-lg md:text-xl text-zinc-400 max-w-2xl mx-auto" data-id="element-415">
            Profesores de toda Argentina ya están transformando sus clases con
            HIIT Pro.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-416">
          {/* Client video */}
          <div className="bg-black border border-zinc-800 rounded-3xl overflow-hidden group cursor-pointer hover:border-primary/40 transition-colors" data-id="element-417">
            <div className="aspect-[4/5] bg-zinc-900 relative flex items-center justify-center" data-id="element-418">
              <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1571019614242-c5c5dee9f50b?q=80&w=800&auto=format&fit=crop')] bg-cover bg-center opacity-40 group-hover:opacity-50 transition-opacity" data-id="element-419" />
              <div className="w-16 h-16 rounded-full bg-primary/90 flex items-center justify-center relative z-10 shadow-[0_0_30px_rgba(249,168,212,0.5)] group-hover:scale-110 transition-transform" data-id="element-420">
                <Play className="w-6 h-6 text-black ml-1" data-id="element-421" />
              </div>
              <span className="absolute top-3 left-3 z-10 bg-black/70 backdrop-blur-sm text-[10px] font-bold text-white uppercase tracking-wider px-2.5 py-1 rounded-full" data-id="element-422">
                Video de cliente
              </span>
            </div>
            <div className="p-5" data-id="element-423">
              <div className="flex text-primary mb-2" data-id="element-424">
                <Star className="w-3.5 h-3.5 fill-current" data-id="element-425" />
                <Star className="w-3.5 h-3.5 fill-current" data-id="element-426" />
                <Star className="w-3.5 h-3.5 fill-current" data-id="element-427" />
                <Star className="w-3.5 h-3.5 fill-current" data-id="element-428" />
                <Star className="w-3.5 h-3.5 fill-current" data-id="element-429" />
              </div>
              <p className="text-sm text-white font-medium leading-snug" data-id="element-430">
                "Recuperé mis domingos y mis alumnos están fascinados."
              </p>
              <p className="text-zinc-500 text-xs mt-2" data-id="element-431">
                — Marcos, Instructor HIIT
              </p>
            </div>
          </div>

          {/* WhatsApp capture */}
          <div className="bg-black border border-zinc-800 rounded-3xl p-5 flex flex-col hover:border-primary/40 transition-colors" data-id="element-432">
            <div className="flex items-center gap-2 mb-4 pb-3 border-b border-zinc-800" data-id="element-433">
              <div className="w-8 h-8 rounded-full bg-[#25D366]/20 flex items-center justify-center" data-id="element-434">
                <MessageCircle className="w-4 h-4 text-[#25D366]" data-id="element-435" />
              </div>
              <span className="text-[11px] font-bold text-zinc-400 uppercase tracking-wider" data-id="element-436">
                Captura de WhatsApp
              </span>
            </div>
            <div className="flex-grow space-y-3" data-id="element-437">
              <div className="bg-zinc-900 rounded-2xl rounded-tl-none p-3 max-w-[90%]" data-id="element-438">
                <p className="text-xs text-zinc-300" data-id="element-439">
                  Apliqué el Tomo 2 hoy y la clase explotó. Me aplaudieron al
                  final 🙌
                </p>
              </div>
              <div className="bg-primary/20 rounded-2xl rounded-tr-none p-3 max-w-[90%] ml-auto" data-id="element-440">
                <p className="text-xs text-white" data-id="element-441">¡A seguir rompiéndola! 🔥</p>
              </div>
              <div className="bg-zinc-900 rounded-2xl rounded-tl-none p-3 max-w-[90%]" data-id="element-442">
                <p className="text-xs text-zinc-300" data-id="element-443">
                  El sistema me salvó la vida, ya no pienso qué dar.
                </p>
              </div>
            </div>
          </div>

          {/* Instagram capture */}
          <div className="bg-black border border-zinc-800 rounded-3xl overflow-hidden flex flex-col hover:border-primary/40 transition-colors" data-id="element-444">
            <div className="p-4 flex items-center gap-2 border-b border-zinc-800" data-id="element-445">
              <div className="w-7 h-7 rounded-full bg-gradient-to-tr from-yellow-400 via-red-500 to-purple-500 flex items-center justify-center" data-id="element-446">
                <Instagram className="w-3.5 h-3.5 text-white" data-id="element-447" />
              </div>
              <span className="text-[11px] font-bold text-zinc-400 uppercase tracking-wider" data-id="element-448">
                Captura de Instagram
              </span>
            </div>
            <div className="aspect-[4/5] bg-zinc-900 relative" data-id="element-449">
              <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1534438327276-14e5300c3a48?q=80&w=800&auto=format&fit=crop')] bg-cover bg-center opacity-50" data-id="element-450" />
              <div className="absolute bottom-4 left-4 right-4 bg-black/80 backdrop-blur-md rounded-xl p-3 border border-zinc-700" data-id="element-451">
                <p className="text-[11px] text-white font-medium leading-snug" data-id="element-452">
                  @profe_valeria: "Clase de mañana lista en 5 minutos gracias a
                  @hiitpro 🚀"
                </p>
              </div>
            </div>
          </div>

          {/* Student photo */}
          <div className="bg-black border border-zinc-800 rounded-3xl overflow-hidden flex flex-col hover:border-primary/40 transition-colors" data-id="element-453">
            <div className="p-4 flex items-center gap-2 border-b border-zinc-800" data-id="element-454">
              <div className="w-7 h-7 rounded-full bg-primary/15 flex items-center justify-center" data-id="element-455">
                <ImageIcon className="w-3.5 h-3.5 text-primary" data-id="element-456" />
              </div>
              <span className="text-[11px] font-bold text-zinc-400 uppercase tracking-wider" data-id="element-457">
                Foto de alumnos
              </span>
            </div>
            <div className="aspect-[4/5] bg-zinc-900 relative" data-id="element-458">
              <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1518611012118-696072aa579a?q=80&w=800&auto=format&fit=crop')] bg-cover bg-center opacity-50" data-id="element-459" />
              <div className="absolute bottom-4 left-4 right-4 bg-black/80 backdrop-blur-md rounded-xl p-3 border border-zinc-700" data-id="element-460">
                <p className="text-[11px] text-white font-medium leading-snug" data-id="element-461">
                  Grupos llenos y motivados clase tras clase.
                </p>
              </div>
            </div>
          </div>
        </div>

        <p className="text-center text-zinc-500 text-sm mt-8" data-id="element-462">
          Espacios preparados para sumar tus propias capturas, fotos y videos
          reales.
        </p>
      </div>
    </section>;
}